<template lang="pug">
  v-container(fill-height fluid)
    .sdo-chat
      v-sheet(color="transparent" dark)
        .d-flex.pb-3.align-center
          v-btn(
            fab small
            depressed
            outlined
            @click="$emit('close')"
          )
            v-icon mdi-chevron-left
          slot(name="header" v-bind="{ closeChat, loading }")
            .ml-4
              h2 {{ title }}
        v-divider(color="#6d6f77")
      v-sheet#chatWindow(
        color="transparent"
        light
      ).sdo-chat__window
        .fill-height.d-flex.align-center.justify-center(v-if="loading.init")
          v-progress-circular(
            indeterminate
            color="white"
            size=70
          )
        template(v-else-if="messages.length")
          v-spacer
          template(
            v-for="(group, day) in groupedMessages"
          )
            .my-2.d-flex.align-center.justify-center(
              :key="day"
            )
              v-chip(color="#ffffff4d" dark).px-10 {{ day }}
            sdo-chat-message(
              v-for="(message, idx) in group"
              :key="`${day}-${idx}`"
              :message="message"
              :selectedProcessedMessage="selectedProcessedMessage"
              @select="selectedProcessedMessage = message"
            )
        .fill-height.d-flex.align-center.justify-center(v-else)
          .text-center.white--text
            strong Здесь пока еще нет сообщений...
            .mt-2 Задайте свой вопрос преподавателю
            .mt-4
              v-icon(size="150" color="white") mdi-chat-question
      v-sheet(color="transparent" dark).sdo-chat__input
        v-expand-transition
          sdo-chat-alert(
            :message="selectedProcessedMessage"
          )
        sdo-chat-input#chatInput.mt-5(
          refs="chatInput"
          :knowledgeBaseId="knowledgeBaseId"
          @unselect="selectedProcessedMessage = null"
        )
</template>

<script>
import _ from 'lodash';
import { parseISO, format } from 'date-fns';

import SdoChatMessage from './SdoChatMessage.vue';
import SdoChatInput from './SdoChatInput.vue';
import SdoChatAlert from './SdoChatAlert.vue';

export default {
  name: 'SdoChat',
  components: {
    SdoChatInput,
    SdoChatAlert,
    SdoChatMessage,
  },
  props: {
    // Chat opened instance of Chat.js model
    chatInstance: { type: Object, required: true },
    title: { type: String, default: 'Чат' },
  },
  provide() {
    return {
      chat: this.chat,
    };
  },
  data() {
    return {
      chat: this.chatInstance,
      knowledgeBaseId: null,
      selectedProcessedMessage: null,
      messages: [],
      loading: {
        init: false,
        close: false,
      },
    };
  },
  computed: {
    groupedMessages() {
      // group messages by day
      return _.groupBy(this.messages, (message) => {
        const date = format(parseISO(message.created_at), 'yyyy-MM-dd');
        return this.$dp.dateprintRelative(date, new Date());
      });
    },
  },
  beforeDestroy() {
    this.chat.disconnect();
  },
  created() {
    this.initMessages();
    this.chat.bindOnMessage((message) => this.onMessage(message));
  },
  methods: {
    async initMessages() {
      this.loading.init = true;
      this.messages = await this.chat.getHistory();
      this.selectedProcessedMessage = this.messages
        .length ? this.messages[this.messages.length - 1] : null;
      if (this.selectedProcessedMessage) {
        const { id } = this.selectedProcessedMessage;
        const { data } = await this.$api.gptPulse.getKnowledgeBaseByMessage(id);
        this.knowledgeBaseId = data.data?.knowledge_base_id;
      }
      this.scrollToBottom({ immediately: false });
      this.loading.init = false;
    },
    onMessage(message) {
      this.messages.push(message);
      this.scrollToBottom();
    },
    scrollToBottom({ immediately } = {}) {
      const duration = immediately ? 0 : 300;
      const chatWindow = document.getElementById('chatWindow');
      this.$vuetify.goTo(chatWindow.scrollHeight - 110, { container: chatWindow, duration });
    },
    async closeChat() {
      this.loading.close = true;
      await this.chat.close();
      this.loading.close = false;
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/mixins.scss';

.sdo-chat {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  max-height: 100%;

  &--loading {
    width: 300px;
    height: 300px;
    border-radius: 40px;
    background-color: rgba(white, .5);
  }

  &__window {
    overflow: hidden auto;
    display: flex;
    flex-grow: 1;
    flex-direction: column;

    &::-webkit-scrollbar {
      background-color: transparent;
      width: 5px;
    }

    &:hover {
      @include sdo-light-scrollbar();
    }
  }

  &__input {
    flex-grow: 0;
  }
}
</style>
